import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteUser, ApiGetUser, ApiGetUserList, ApiRegister, ApiUpdateUser } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function UserService() {
    const { showFail } = useModal()

    const { fetch: apiGetUserList } = useFetch(ApiGetUserList)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiCreateUser } = useFetch(ApiRegister)
    const { fetch: apiUpdateUser } = useFetch(ApiUpdateUser)
    const { fetch: apiGetUserById } = useFetch(ApiGetUser)
 
    const fetchUserList = async (username, name, status, pageSize, pageIndex, pageType, sortBy, sortOrder) => {
        const res = await apiGetUserList({
            data: {
                username,
                name,
                status,
                pageSize,
                pageIndex,
                pageType,
                sortBy,
                sortOrder
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteUser = async (userId, status) => {
        const res = await apiDeleteUser({
            data: {
                userId, 
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateUser = async (username, firstName, lastName, email, password, isAdmin) => {
        const res = await apiCreateUser({
            data: {
                username,
                firstName,
                lastName,
                email,
                password,
                isAdmin
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateUser = async (userId, username, firstName, lastName, email, password, isAdmin) => {
        const res = await apiUpdateUser({
            data: {
                userId,
                username,
                firstName,
                lastName,
                email,
                password,
                isAdmin
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUserById = async (userId) => {
        const res = await apiGetUserById({
            data: {
                userId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchUserList,
        fetchDeleteUser,
        fetchCreateUser,
        fetchUpdateUser,
        fetchUserById
    }
}